import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { TourSearchDestination, TownShort } from 'shared/api/tours/search'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  destination: TourSearchDestination
  onClick?: () => void
}

export const DirectionCardSecondary = ({ destination, onClick }: Props) => {
  const { t } = useTranslation()

  const visaText = destination?.is_visa_required
    ? t('visa_required')
    : t('without_visa')

  const formatCitiesList = (towns?: TownShort[], visibleCount = 2) => {
    if (!towns?.length) return ''

    const displayedNames = towns
      .slice(0, visibleCount)
      .map((town) => town.name)
      .join(', ')

    const remaining = towns.length - visibleCount

    return remaining > 0
      ? t('tours_block.cities_and_more', {
          displayed: displayedNames,
          remaining,
        })
      : displayedNames
  }

  return (
    <div
      className={s.container}
      onClick={onClick}
    >
      <div className={s.box}>
        <div className={s.imageBox}>
          <ImageLazy
            className={s.image}
            src={destination?.image_landmark ?? undefined}
            alt={destination?.name}
          />

          {destination?.flag && (
            <div className={s.flag}>
              <ImageLazy
                className={s.flagImage}
                src={destination?.flag ?? undefined}
                alt={destination?.name}
              />
            </div>
          )}
        </div>

        <div className={s.info}>
          <p className={clsx(s.visa, 'medium-12')}>{visaText}</p>

          <p className={clsx(s.country, 'bold-14')}>{destination?.name}</p>
          <p className={clsx(s.cities, 'medium-12')}>
            {formatCitiesList(destination?.cities)}
          </p>
        </div>
      </div>

      <AppIcon
        id={AllIcons.ARROW_RIGHT_BOLD}
        width={20}
        height={20}
      />
    </div>
  )
}
